/**
 * @fileoverview gRPC-Web generated client stub for payments
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');

const proto = {};
proto.payments = require('./payments_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.payments.SubscriptionsClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.payments.SubscriptionsPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.payments.CreateSubscriptionRequest,
 *   !proto.payments.CreateSubscriptionResponse>}
 */
const methodDescriptor_Subscriptions_Create = new grpc.web.MethodDescriptor(
  '/payments.Subscriptions/Create',
  grpc.web.MethodType.UNARY,
  proto.payments.CreateSubscriptionRequest,
  proto.payments.CreateSubscriptionResponse,
  /**
   * @param {!proto.payments.CreateSubscriptionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.payments.CreateSubscriptionResponse.deserializeBinary
);


/**
 * @param {!proto.payments.CreateSubscriptionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.payments.CreateSubscriptionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.payments.CreateSubscriptionResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.payments.SubscriptionsClient.prototype.create =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/payments.Subscriptions/Create',
      request,
      metadata || {},
      methodDescriptor_Subscriptions_Create,
      callback);
};


/**
 * @param {!proto.payments.CreateSubscriptionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.payments.CreateSubscriptionResponse>}
 *     Promise that resolves to the response
 */
proto.payments.SubscriptionsPromiseClient.prototype.create =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/payments.Subscriptions/Create',
      request,
      metadata || {},
      methodDescriptor_Subscriptions_Create);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.payments.UpdateSubscriptionRequest,
 *   !proto.payments.UpdateSubscriptionResponse>}
 */
const methodDescriptor_Subscriptions_Update = new grpc.web.MethodDescriptor(
  '/payments.Subscriptions/Update',
  grpc.web.MethodType.UNARY,
  proto.payments.UpdateSubscriptionRequest,
  proto.payments.UpdateSubscriptionResponse,
  /**
   * @param {!proto.payments.UpdateSubscriptionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.payments.UpdateSubscriptionResponse.deserializeBinary
);


/**
 * @param {!proto.payments.UpdateSubscriptionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.payments.UpdateSubscriptionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.payments.UpdateSubscriptionResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.payments.SubscriptionsClient.prototype.update =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/payments.Subscriptions/Update',
      request,
      metadata || {},
      methodDescriptor_Subscriptions_Update,
      callback);
};


/**
 * @param {!proto.payments.UpdateSubscriptionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.payments.UpdateSubscriptionResponse>}
 *     Promise that resolves to the response
 */
proto.payments.SubscriptionsPromiseClient.prototype.update =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/payments.Subscriptions/Update',
      request,
      metadata || {},
      methodDescriptor_Subscriptions_Update);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.payments.ListSubscriptionRequest,
 *   !proto.payments.ListSubscriptionResponse>}
 */
const methodDescriptor_Subscriptions_List = new grpc.web.MethodDescriptor(
  '/payments.Subscriptions/List',
  grpc.web.MethodType.UNARY,
  proto.payments.ListSubscriptionRequest,
  proto.payments.ListSubscriptionResponse,
  /**
   * @param {!proto.payments.ListSubscriptionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.payments.ListSubscriptionResponse.deserializeBinary
);


/**
 * @param {!proto.payments.ListSubscriptionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.payments.ListSubscriptionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.payments.ListSubscriptionResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.payments.SubscriptionsClient.prototype.list =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/payments.Subscriptions/List',
      request,
      metadata || {},
      methodDescriptor_Subscriptions_List,
      callback);
};


/**
 * @param {!proto.payments.ListSubscriptionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.payments.ListSubscriptionResponse>}
 *     Promise that resolves to the response
 */
proto.payments.SubscriptionsPromiseClient.prototype.list =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/payments.Subscriptions/List',
      request,
      metadata || {},
      methodDescriptor_Subscriptions_List);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.payments.GetSubscriptionRequest,
 *   !proto.payments.GetSubscriptionResponse>}
 */
const methodDescriptor_Subscriptions_Get = new grpc.web.MethodDescriptor(
  '/payments.Subscriptions/Get',
  grpc.web.MethodType.UNARY,
  proto.payments.GetSubscriptionRequest,
  proto.payments.GetSubscriptionResponse,
  /**
   * @param {!proto.payments.GetSubscriptionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.payments.GetSubscriptionResponse.deserializeBinary
);


/**
 * @param {!proto.payments.GetSubscriptionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.payments.GetSubscriptionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.payments.GetSubscriptionResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.payments.SubscriptionsClient.prototype.get =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/payments.Subscriptions/Get',
      request,
      metadata || {},
      methodDescriptor_Subscriptions_Get,
      callback);
};


/**
 * @param {!proto.payments.GetSubscriptionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.payments.GetSubscriptionResponse>}
 *     Promise that resolves to the response
 */
proto.payments.SubscriptionsPromiseClient.prototype.get =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/payments.Subscriptions/Get',
      request,
      metadata || {},
      methodDescriptor_Subscriptions_Get);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.payments.DeleteSubscriptionRequest,
 *   !proto.payments.DeleteSubscriptionResponse>}
 */
const methodDescriptor_Subscriptions_Delete = new grpc.web.MethodDescriptor(
  '/payments.Subscriptions/Delete',
  grpc.web.MethodType.UNARY,
  proto.payments.DeleteSubscriptionRequest,
  proto.payments.DeleteSubscriptionResponse,
  /**
   * @param {!proto.payments.DeleteSubscriptionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.payments.DeleteSubscriptionResponse.deserializeBinary
);


/**
 * @param {!proto.payments.DeleteSubscriptionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.payments.DeleteSubscriptionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.payments.DeleteSubscriptionResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.payments.SubscriptionsClient.prototype.delete =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/payments.Subscriptions/Delete',
      request,
      metadata || {},
      methodDescriptor_Subscriptions_Delete,
      callback);
};


/**
 * @param {!proto.payments.DeleteSubscriptionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.payments.DeleteSubscriptionResponse>}
 *     Promise that resolves to the response
 */
proto.payments.SubscriptionsPromiseClient.prototype.delete =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/payments.Subscriptions/Delete',
      request,
      metadata || {},
      methodDescriptor_Subscriptions_Delete);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.payments.CreateSubscriptionRequest,
 *   !proto.payments.UpdateSubscriptionResponse>}
 */
const methodDescriptor_Subscriptions_ChangeSubscriptionPlan = new grpc.web.MethodDescriptor(
  '/payments.Subscriptions/ChangeSubscriptionPlan',
  grpc.web.MethodType.UNARY,
  proto.payments.CreateSubscriptionRequest,
  proto.payments.UpdateSubscriptionResponse,
  /**
   * @param {!proto.payments.CreateSubscriptionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.payments.UpdateSubscriptionResponse.deserializeBinary
);


/**
 * @param {!proto.payments.CreateSubscriptionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.payments.UpdateSubscriptionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.payments.UpdateSubscriptionResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.payments.SubscriptionsClient.prototype.changeSubscriptionPlan =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/payments.Subscriptions/ChangeSubscriptionPlan',
      request,
      metadata || {},
      methodDescriptor_Subscriptions_ChangeSubscriptionPlan,
      callback);
};


/**
 * @param {!proto.payments.CreateSubscriptionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.payments.UpdateSubscriptionResponse>}
 *     Promise that resolves to the response
 */
proto.payments.SubscriptionsPromiseClient.prototype.changeSubscriptionPlan =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/payments.Subscriptions/ChangeSubscriptionPlan',
      request,
      metadata || {},
      methodDescriptor_Subscriptions_ChangeSubscriptionPlan);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.payments.Empty,
 *   !proto.payments.UpdateSubscriptionResponse>}
 */
const methodDescriptor_Subscriptions_CancelSubscription = new grpc.web.MethodDescriptor(
  '/payments.Subscriptions/CancelSubscription',
  grpc.web.MethodType.UNARY,
  proto.payments.Empty,
  proto.payments.UpdateSubscriptionResponse,
  /**
   * @param {!proto.payments.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.payments.UpdateSubscriptionResponse.deserializeBinary
);


/**
 * @param {!proto.payments.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.payments.UpdateSubscriptionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.payments.UpdateSubscriptionResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.payments.SubscriptionsClient.prototype.cancelSubscription =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/payments.Subscriptions/CancelSubscription',
      request,
      metadata || {},
      methodDescriptor_Subscriptions_CancelSubscription,
      callback);
};


/**
 * @param {!proto.payments.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.payments.UpdateSubscriptionResponse>}
 *     Promise that resolves to the response
 */
proto.payments.SubscriptionsPromiseClient.prototype.cancelSubscription =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/payments.Subscriptions/CancelSubscription',
      request,
      metadata || {},
      methodDescriptor_Subscriptions_CancelSubscription);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.payments.Empty,
 *   !proto.payments.GetSubscriptionResponse>}
 */
const methodDescriptor_Subscriptions_GetSubscriptionInfo = new grpc.web.MethodDescriptor(
  '/payments.Subscriptions/GetSubscriptionInfo',
  grpc.web.MethodType.UNARY,
  proto.payments.Empty,
  proto.payments.GetSubscriptionResponse,
  /**
   * @param {!proto.payments.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.payments.GetSubscriptionResponse.deserializeBinary
);


/**
 * @param {!proto.payments.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.payments.GetSubscriptionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.payments.GetSubscriptionResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.payments.SubscriptionsClient.prototype.getSubscriptionInfo =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/payments.Subscriptions/GetSubscriptionInfo',
      request,
      metadata || {},
      methodDescriptor_Subscriptions_GetSubscriptionInfo,
      callback);
};


/**
 * @param {!proto.payments.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.payments.GetSubscriptionResponse>}
 *     Promise that resolves to the response
 */
proto.payments.SubscriptionsPromiseClient.prototype.getSubscriptionInfo =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/payments.Subscriptions/GetSubscriptionInfo',
      request,
      metadata || {},
      methodDescriptor_Subscriptions_GetSubscriptionInfo);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.payments.Empty,
 *   !proto.payments.InvoicesList>}
 */
const methodDescriptor_Subscriptions_ListInvoices = new grpc.web.MethodDescriptor(
  '/payments.Subscriptions/ListInvoices',
  grpc.web.MethodType.UNARY,
  proto.payments.Empty,
  proto.payments.InvoicesList,
  /**
   * @param {!proto.payments.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.payments.InvoicesList.deserializeBinary
);


/**
 * @param {!proto.payments.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.payments.InvoicesList)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.payments.InvoicesList>|undefined}
 *     The XHR Node Readable Stream
 */
proto.payments.SubscriptionsClient.prototype.listInvoices =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/payments.Subscriptions/ListInvoices',
      request,
      metadata || {},
      methodDescriptor_Subscriptions_ListInvoices,
      callback);
};


/**
 * @param {!proto.payments.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.payments.InvoicesList>}
 *     Promise that resolves to the response
 */
proto.payments.SubscriptionsPromiseClient.prototype.listInvoices =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/payments.Subscriptions/ListInvoices',
      request,
      metadata || {},
      methodDescriptor_Subscriptions_ListInvoices);
};


module.exports = proto.payments;

